import React from 'react'

import { SegmentedDateTimePicker } from './SegmentedDateTimePicker/index.web'
import type { Props } from './types'

const DateTimePicker = (props: Props) => {
  if (props.variant !== 'segmented') {
    throw new Error(
      'DateTimePicker on web requires variant="segmented". The inline modal calendar variant is native-only; pass `variant="segmented"` explicitly when rendering on web.'
    )
  }
  return <SegmentedDateTimePicker {...props} />
}

export default DateTimePicker
